<template>
  <div class="components-drop-down-filter w-100">
    <button class="btn w-100" @click="showItems = !showItems">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center" v-if="count > 3">
          <i class="icon-queue-music mr-2 icon-size"></i>
          <h5 class="my-0">
            Tema
          </h5>
        </div>
        <div class="d-flex align-items-center" v-else>
          <i class="icon-calm mr-2 icon-size"></i>
          <h5 class="my-0">
            Intensidade
          </h5>
        </div>
        <i class="icon-chevron-down ml-2"></i>
      </div>
    </button>
    <div v-if="showItems" class="w-100 position-relative bg-dark">
      <div v-if="count > 3">
        <div class="row justify-content-center">
          <div class="col-6 pr-0">
            <btn-drop-down
              v-for="item in items.slice(0, count / 2)"
              :key="item.id"
              :item="item"
              @select-item="addItemsToSelected(item)"
              :orderElements="true"
              :select="selected.includes(item)"
            />
          </div>
          <div class="col-6 pl-0">
            <btn-drop-down
              v-for="item in items.slice(count / 2, count)"
              :key="item.id"
              :item="item"
              @select-item="addItemsToSelected(item)"
              :orderElements="true"
              :select="selected.includes(item)"
            />
          </div>
        </div>
      </div>
      <div v-else>
        <btn-drop-down
          v-for="item in items"
          :key="item.id"
          :item="item"
          @select-item="addItemsToSelected(item)"
          :orderElements="true"
          :select="selected.includes(item)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BtnDropDown from "./BtnDropDown.vue";
export default {
  components: { BtnDropDown },
  data() {
    return {
      showItems: false,
      selected: [],
      count: this.items.length
    };
  },
  props: {
    items: {
      type: Array,
      default: () => [
        { name: "Calma", id: 1 },
        { name: "Média", id: 2 },
        { name: "Agitada", id: 3 }
      ]
    }
  },
  methods: {
    addItemsToSelected(theme) {
      if (this.selected.includes(theme)) {
        const index = this.selected.indexOf(theme);
        this.selected.splice(index, 1);
      } else {
        this.selected.push(theme);
      }
      const ids = this.selected.map(rep => rep.id);
      if (this.items.length > 3) {
        this.$emit("getRepertoriesByFilters", { idsThemes: ids });
      } else {
        this.$emit("getRepertoriesByFilters", { idsIntensities: ids });
      }
    }
  },
  computed: {
    textDropdown() {
      if (this.selected.length > 0) {
        return this.selected[0].text;
      } else {
        return this.repertories[0].text;
      }
    }
  },
  watch: {
    selected(newValue) {
      this.selected = newValue;
    }
  }
};
</script>

<style lang="scss" scoped>
.components-drop-down-filter {
  .icon-size {
    font-size: 20px;
  }
  ::v-deep .custom-control-label::after {
    display: none;
  }

  ::v-deep .custom-control-label::before {
    display: none;
  }

  button {
    background: #111112;
    border: none;
    z-index: 2;
    color: #fff;
    border-radius: 0 !important;
  }

  .bg-dark {
    background: #111112;
    z-index: 10;
  }
}
</style>
